import { Components } from "@mui/material/styles";

export default {
  MuiTableCell: {
    styleOverrides: {
      root: {
        fontFamily: "unset",
      },
    },
  } as Components["MuiTableCell"],
};
